import script from "./CallBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./CallBtn.vue?vue&type=script&setup=true&lang=js"

import "./CallBtn.vue?vue&type=style&index=0&id=3d266620&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d266620"]])

export default __exports__